import React, { FC } from 'react';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Payroll, Transaction } from '~/types';
import c from '~/utils/constants';
import { TextField, TransactionResult } from '~/components';
import theme from '~/theme';
import TransactionDetails from '~/pages/payrolls/components/TransactionDetails';

interface Props {
  transaction: Transaction;
  payroll?: Partial<Payroll>;
  className?: string;
  onClose: () => void;
}

const SuccessScreen: FC<Props> = (props) => {
  const { transaction, className, onClose, payroll } = props;
  const [t] = useTranslation('payrolls');

  return (
    <div className={className}>
      <TransactionResult
        title={t('Payroll has been initiated')}
        transaction={transaction}
        onClose={onClose}
      />
      <div className="SuccessScreen-Result">
        <ResultCell>
          <Space direction="vertical" size={16}>
            <TextField label={t('From account')}>{transaction?.sender.accountNumber}</TextField>
          </Space>
        </ResultCell>
        <ResultCell>
          <Space direction="vertical" className="full-width" size={16}>
            <div className="AmountAndConsent-Details">
              <TransactionDetails data={transaction} payroll={payroll} />
            </div>
          </Space>
        </ResultCell>
      </div>
    </div>
  );
};

const ResultCell: FC<any> = (props) => {
  const { children } = props;
  return <div className="SuccessScreen-ResultCell">{children}</div>;
};

export default styled(SuccessScreen)`
  .SuccessScreen-Result {
    border-radius: ${c.borderRadiusBase}px;
    overflow: hidden;
    border: 1px solid #f0f0f0;

    .SuccessScreen-ResultCell {
      padding: 16px 20px;
      background-color: #ffffff;
      border-bottom: 1px solid #f0f0f0;

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .SuccessScreen-TotalAmount {
    color: ${theme.primaryColor};
  }
`;
